import { Spinner } from 'components/ui/spinner';
import React from 'react';

interface LoadingPageProps {
  // Optional with a default: LoadingPage is used as a bare Suspense fallback
  // (e.g. <LoadingPage />) as well as with an explicit message.
  message?: string;
}

const LoadingPage = ({ message = 'Loading' }: LoadingPageProps) => {
  return (
    <div className="flex h-[67vh] flex-col items-center justify-center text-center">
      <Spinner className="size-10" />
      <div className="mt-5 text-base">
        {message}
      </div>
    </div>
  );
};

export default LoadingPage;
